<template lang="pug">
.container.grid-lg
  .text-bold.my-2.py-2 Relatórios disponíveis para análises

  .columns
    .column.col-4.col-lg-6.col-md-12.mb-2.pb-2(v-for="item in items")
      row(v-bind="item", v-acl:allowed="item.acl")
</template>

<script>
import Row from "../components/ReportRow"

export default {
  components: { Row },
  computed: {
    items() {
      return [
        {
          icon: "fa fa-bookmark",
          title: "Situações por mês",
          subtitle: "Quantidade de análises agrupadas por situação e mês",
          to: { name: "app.indicadores.analises.situacoesPorMes" },
          acl: ["admin", "indicadores", "analises", "situacoes_por_meses"],
        },
        {
          icon: "fa fa-list",
          title: "Por situação",
          subtitle: "Quantidade de análises por situação",
          to: { name: "app.indicadores.analises.situacoes" },
          acl: ["admin", "indicadores", "analises", "situacoes"],
        },
        {
          icon: "fa fa-user-secret",
          title: "Analistas por mês",
          subtitle: "Quantidade de análises agrupadas por analista e mês",
          to: { name: "app.indicadores.analises.analistasPorMes" },
          acl: ["admin", "indicadores", "analises", "analistas_por_meses"],
        },
      ]
    },
  },
}
</script>
